import React, { useEffect, useRef } from 'react';
import debounce from 'lodash.debounce';
import { observable } from 'mobx';

class BaseSwiperStore {
  @observable
  swiperOptions = {
    loop: true,
    spaceBetween: 0,
    autoplay: {
      disableOnInteraction: false,
      delay: 4000
    }
  };

  @observable activeIndex = 0;
  @observable size = 0;

  constructor({ ...rest } = {}) {
    Object.assign(this, rest);
  }

  goNext = () => {
    const swiper = this.swiperRef.current.swiper;
    swiper.slideNext();
  };

  goPrev = () => {
    const swiper = this.swiperRef.current.swiper;
    swiper.slidePrev();
  };

  onChange = activeIndex => {
    this.activeIndex = activeIndex;
  };

  isDisabled() {
    return this.size < 2;
  }

  use({ children }) {
    this.size = React.Children.count(children);

    const swiperRef = (this.swiperRef = useRef());
    this.onResize = debounce(() => {
      swiperRef.current?.swiper.update();
    }, 500);

    useEffect(
      () => {
        const onResize = this.onResize;
        window.addEventListener('resize', onResize);
        return () => {
          window.removeEventListener('resize', onResize);
        };
      },
      [this.onResize]
    );

    useEffect(() => {
      const swiper = this.swiperRef.current.swiper;
      const context = this;
      swiper.on('slideChange', function() {
        context.onSlideChange?.(swiper.realIndex);
        // debounce(() => {
        context.activeIndex = swiper.realIndex;
        // }, 500);
      });
    }, []);

    useEffect(
      () => {
        if (this.swiperRef.current.swiper?.realIndex !== this.activeIndex) {
          const swiper = this.swiperRef.current.swiper;
          swiper.slideToLoop(this.activeIndex);
        }
      },
      [this.activeIndex]
    );
  }
}

export default BaseSwiperStore;
